export default __webpack_public_path__ + "static/media/preview-background.a722f7c7.jpg";